import { graphql } from '../gql';
import { useMutation } from 'urql';
const setPersonalInfoMutation = graphql(`
  mutation SetProfileInfo($profileInfo: SetProfileInfoDto!) {
    setProfileInfo(profileInfo: $profileInfo) {
      customer {
        ...Customer
      }
      user {
        ...CurrentUser
      }
    }
  }
`);
export const useSetPersonalInfoMutation = () => useMutation(setPersonalInfoMutation);
